module.exports = __webpack_public_path__ + "static/media/twvolumetric.68414b78.png";